import { BaseService } from "services/_baseService";

class StationsAdminService extends BaseService<any> {
  constructor() {
    super(`stations`);
  }
}

export default new StationsAdminService();
